import type { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { vehicleDriverAssignmentTransitionRefs } from "../subjects/vehicleDriverAssignmentTransition/refs";

/**
 * The driver left the unit.
 *
 * No role: a detach closes whatever seat the driver had open on that unit, so stating one would only invite a
 * disagreement with the attach it closes.
 */
export const vehicleDetachedV1 = tmsEventKind(
  { category: "vehicleAssignment", kind: "vehicleDetached", version: 1 },
  { refs: vehicleDriverAssignmentTransitionRefs, facts: {} },
);

export const VehicleDetachedV1Schema = vehicleDetachedV1.schema;
export const VehicleDetachedV1FactsSchema = vehicleDetachedV1.facts;

export type VehicleDetachedV1 = z.infer<typeof VehicleDetachedV1Schema>;
export type VehicleDetachedV1Facts = z.infer<typeof VehicleDetachedV1FactsSchema>;

/** Every version of `vehicleDetached`, keyed by version. What `catalog.ts` places under `vehicleAssignment`. */
export const vehicleDetached = { 1: vehicleDetachedV1 } as const;
